import React from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

import './AppError.scss'

import Section from '../Section'
import HomeLink from '../HomeLink'
import Social from '../Social'

const AppError = () => {
    return (
        <>
            <Section
                name="mga-error"
                className="mga-error-section"
                motionProps={{
                    initial: { opacity: 0 },
                    animate: { opacity: 1 },
                    exit: { opacity: 0 },
                    transition: { duration: 0.5 }
                }}
            >
                <HomeLink whitemode={true} />
                <motion.p>
                    Nuestro sitio está teniendo dificultades técnicas.<br />
                    Por favor intente de nuevo más tarde.
                </motion.p>
                <Social whitemode={true} />
            </Section>
        </>
    )
}

export default React.memo(AppError)